{
  "admins": {
    "errors": {
      "add": "Failed to add admin.",
      "notFound": "Could not find that admin."
    }
  },
  "clinicManagement": {
    "addButton": "Add Clinic",
    "form": {
      "createTitle": "Create Clinic",
      "errors": {
        "logoTooLarge": "Logo file must be under 2 MB",
        "logoUploadFailed": "Failed to upload logo",
        "name": "Name is required",
        "states": "US States are required",
        "unableToUpdate": "Unable to update clinic: {{error}}"
      },
      "formSubmission": {
        "createError": "Failed to create clinic",
        "createSuccess": "Clinic created successfully",
        "updateError": "Failed to update clinic",
        "updateSuccess": "Clinic updated successfully"
      },
      "logo": "Logo",
      "name": "Name",
      "replaceLogo": "Replace Logo",
      "states": "US States",
      "statesPlaceholder": "Select US States",
      "updateTitle": "Edit Clinic"
    },
    "searchPlaceholder": "Search clinics",
    "table": {
      "header": {
        "createdAt": "Created At",
        "logo": "Logo",
        "name": "Name",
        "state": "US States",
        "updatedAt": "Updated At",
        "workspaceId": "Workspace ID"
      }
    },
    "title": "Clinic Management"
  },
  "documentDownload": {
    "errorLoading": "An error occurred while loading the document.\n\nPlease try again later.",
    "noFilesErrorToast": "No files available for download.",
    "successToast": "Document downloaded successfully.",
    "unknownErrorToast": "Failed to download document."
  },
  "home": {
    "goToSandbox": "Go to the sandbox",
    "subtitle": "This repo is a a starting point to build web apps with React, shadcn-ui and TanStack Router.",
    "title": "Welcome to the Mindsea React Template."
  },
  "login": {
    "title": "Login"
  },
  "sessionTimedOut": {
    "description": "You have been logged out due to inactivity. Please log in again to continue.",
    "loginAgain": "Log In Again",
    "returnToHomepage": "Return to Homepage",
    "title": "Logged Out"
  },
  "sessionTimeout": {
    "countdown": "{{time}} remaining",
    "description": "Your session is about to expire due to inactivity. Would you like to stay logged in?",
    "logOutNow": "Log Out Now",
    "secureSession": "Secure Session",
    "stayLoggedIn": "Stay Logged In",
    "title": "Session Timeout"
  }
}
